export enum EntitiesFetchingStatus {
	Idle = 'Idle',
	Pending = 'Pending',
	Success = 'Success',
	Error = 'Error',
}
